function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Shape",
  width: 24,
  height: 24,
  fill: "#7e27e4",
  opacity: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148958",
  d: "M9.115,19.316H16.1a1.477,1.477,0,0,0,1.645-1.541l.465-10.658h1.018a.656.656,0,0,0,.664-.664.649.649,0,0,0-.664-.649h-3.2V4.7A1.8,1.8,0,0,0,14,2.817h-2.8A1.8,1.8,0,0,0,9.166,4.7V5.8H5.98a.656.656,0,1,0,0,1.313H7.005l.472,10.658A1.468,1.468,0,0,0,9.115,19.316ZM10.7,4.765a.534.534,0,0,1,.6-.546h2.6a.534.534,0,0,1,.6.546V5.8H10.7Zm-.465,12.288a.478.478,0,0,1-.509-.487L9.506,8.733a.469.469,0,0,1,.509-.494.479.479,0,0,1,.509.487l.221,7.833A.462.462,0,0,1,10.236,17.052Zm2.368,0a.473.473,0,0,1-.516-.487V8.725a.477.477,0,0,1,.516-.487.483.483,0,0,1,.524.487v7.84A.479.479,0,0,1,12.6,17.052Zm2.368.007a.465.465,0,0,1-.509-.494l.221-7.84a.479.479,0,0,1,.509-.487.469.469,0,0,1,.509.494l-.221,7.833A.484.484,0,0,1,14.971,17.06Z",
  transform: "translate(-0.604 0.934)"
});

function SvgTrashBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sun_Brightens",
    "data-name": "Sun / Brightens",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBasket);
export default __webpack_public_path__ + "static/media/trash-basket.418ce463.svg";
export { ForwardRef as ReactComponent };